// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.LoadingProduct_details-container__qXokp {
  display: flex;
  gap: 28px;
}
.LoadingProduct_details-container__qXokp .LoadingProduct_images-container__BamuH {
  width: 33%;
  display: flex;
}
.LoadingProduct_details-container__qXokp .LoadingProduct_images-container__BamuH .LoadingProduct_carousel-container__HJpCc {
  width: 100%;
}
.LoadingProduct_details-container__qXokp .LoadingProduct_product-props-container__zoPti {
  width: 33%;
}
.LoadingProduct_details-container__qXokp .LoadingProduct_product-props-container__zoPti .LoadingProduct_title-loading__9snVo {
  height: 20px;
  width: 200px;
}
.LoadingProduct_details-container__qXokp .LoadingProduct_product-props-container__zoPti .LoadingProduct_subtitle-loading__gdtd\\+ {
  height: 20px;
  width: 100%;
}
.LoadingProduct_details-container__qXokp .LoadingProduct_product-props-container__zoPti .LoadingProduct_values-container-loading__XqaXe {
  height: 25px;
  width: 60px;
  display: inline-block;
  margin-top: 5px;
  margin-right: 20px;
}
.LoadingProduct_details-container__qXokp .LoadingProduct_product-props-container__zoPti .LoadingProduct_values-title-loading__K5bXe {
  height: 20px;
  width: 60px;
  margin-top: 10px;
}

.LoadingProduct_summary__kso5S {
  display: flex;
  width: 33%;
  flex-direction: column;
  align-items: center;
}
.LoadingProduct_summary__kso5S .LoadingProduct_price-loading__FQoJu {
  height: 35px;
}
.LoadingProduct_summary__kso5S .LoadingProduct_price-box__bw-VJ .LoadingProduct_quantity-container__mXPYb {
  font-size: 16px;
}
.LoadingProduct_summary__kso5S .LoadingProduct_price-box__bw-VJ .LoadingProduct_quantity-container__mXPYb .LoadingProduct_quantity-title-loading__wzz2T {
  height: 25px;
  width: 26vw;
  margin-top: 10px;
}
.LoadingProduct_summary__kso5S .LoadingProduct_price-box__bw-VJ .LoadingProduct_quantity-container__mXPYb .LoadingProduct_quantity-label-loading__tjB-d {
  height: 20px;
  width: 100px;
  margin-top: 10px;
}
.LoadingProduct_summary__kso5S .LoadingProduct_price-box__bw-VJ .LoadingProduct_quantity-container__mXPYb .LoadingProduct_quantity-input-loading__KMUzh {
  height: 35px;
  width: 100%;
  margin-top: 5px;
}
.LoadingProduct_summary__kso5S .LoadingProduct_price-box__bw-VJ .LoadingProduct_quantity-container__mXPYb .LoadingProduct_quantity-button-loading__Vb8Z6 {
  height: 30px;
  width: 100%;
  margin-top: 10px;
}

.LoadingProduct_loading__Ckj9Y {
  background: linear-gradient(-45deg, #ffffff, rgb(219, 214, 214));
  background-size: 400% 400%;
  animation: LoadingProduct_gradient__DBJD8 4s ease infinite;
}

@keyframes LoadingProduct_gradient__DBJD8 {
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
}
@media (min-width: 1360px) {
  .LoadingProduct_carousel-container__HJpCc {
    min-height: 550px;
  }
}`, "",{"version":3,"sources":["webpack://./src/views/ProductDetailView/LoadingProduct/LoadingProduct.module.scss","webpack://./src/styles/_typography.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,SAAA;AAFF;AAGE;EACE,UAAA;EACA,aAAA;AADJ;AAEI;EACE,WAAA;AAAN;AAIE;EACE,UAAA;AAFJ;AAII;EACE,YAAA;EACA,YAAA;AAFN;AAKI;EACE,YAAA;EACA,WAAA;AAHN;AAMI;EACE,YAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;EACA,kBAAA;AAJN;AAOI;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AALN;;AAUA;EACE,aAAA;EACA,UAAA;EACA,sBAAA;EACA,mBAAA;AAPF;AASE;EACE,YAAA;AAPJ;AAWI;EACE,eCrDG;AD4CT;AAWM;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AATR;AAYM;EACE,YAAA;EACA,YAAA;EACA,gBAAA;AAVR;AAaM;EACE,YAAA;EACA,WAAA;EACA,eAAA;AAXR;AAcM;EACE,YAAA;EACA,WAAA;EACA,gBAAA;AAZR;;AAkBA;EACE,gEAAA;EACA,0BAAA;EACA,0DAAA;AAfF;;AAkBA;EACE;IACE,2BAAA;EAfF;EAkBA;IACE,6BAAA;EAhBF;EAmBA;IACE,2BAAA;EAjBF;AACF;AAoBA;EACE;IACE,iBAAA;EAlBF;AACF","sourcesContent":["@use \"styles/typography\";\n@use \"styles/colors\";\n\n.details-container {\n  display: flex;\n  gap: 28px;\n  .images-container {\n    width: 33%;\n    display: flex;\n    .carousel-container {\n      width: 100%;\n    }\n  }\n\n  .product-props-container {\n    width: 33%;\n\n    .title-loading {\n      height: 20px;\n      width: 200px;\n    }\n\n    .subtitle-loading {\n      height: 20px;\n      width: 100%;\n    }\n\n    .values-container-loading {\n      height: 25px;\n      width: 60px;\n      display: inline-block;\n      margin-top: 5px;\n      margin-right: 20px;\n    }\n\n    .values-title-loading {\n      height: 20px;\n      width: 60px;\n      margin-top: 10px;\n    }\n  }\n}\n\n.summary {\n  display: flex;\n  width: 33%;\n  flex-direction: column;\n  align-items: center;\n\n  .price-loading {\n    height: 35px;\n  }\n\n  .price-box {\n    .quantity-container {\n      font-size: typography.$body-l;\n\n      .quantity-title-loading {\n        height: 25px;\n        width: 26vw;\n        margin-top: 10px;\n      }\n\n      .quantity-label-loading {\n        height: 20px;\n        width: 100px;\n        margin-top: 10px;\n      }\n\n      .quantity-input-loading {\n        height: 35px;\n        width: 100%;\n        margin-top: 5px;\n      }\n\n      .quantity-button-loading {\n        height: 30px;\n        width: 100%;\n        margin-top: 10px;\n      }\n    }\n  }\n}\n\n.loading {\n  background: linear-gradient(-45deg, #ffffff, rgb(219, 214, 214));\n  background-size: 400% 400%;\n  animation: gradient 4s ease infinite;\n}\n\n@keyframes gradient {\n  0% {\n    background-position: 0% 50%;\n  }\n\n  50% {\n    background-position: 100% 50%;\n  }\n\n  100% {\n    background-position: 0% 50%;\n  }\n}\n\n@media (min-width: 1360px) {\n  .carousel-container {\n    min-height: 550px;\n  }\n}\n","$body-s: 12px;\n$body-m: 14px;\n$body-l: 16px;\n$header-xs: 18px;\n$header-s: 20px;\n$header-m: 24px;\n$header-l: 34px;\n$bold: bold;\n$semi-bold: 600;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"details-container": `LoadingProduct_details-container__qXokp`,
	"images-container": `LoadingProduct_images-container__BamuH`,
	"carousel-container": `LoadingProduct_carousel-container__HJpCc`,
	"product-props-container": `LoadingProduct_product-props-container__zoPti`,
	"title-loading": `LoadingProduct_title-loading__9snVo`,
	"subtitle-loading": `LoadingProduct_subtitle-loading__gdtd+`,
	"values-container-loading": `LoadingProduct_values-container-loading__XqaXe`,
	"values-title-loading": `LoadingProduct_values-title-loading__K5bXe`,
	"summary": `LoadingProduct_summary__kso5S`,
	"price-loading": `LoadingProduct_price-loading__FQoJu`,
	"price-box": `LoadingProduct_price-box__bw-VJ`,
	"quantity-container": `LoadingProduct_quantity-container__mXPYb`,
	"quantity-title-loading": `LoadingProduct_quantity-title-loading__wzz2T`,
	"quantity-label-loading": `LoadingProduct_quantity-label-loading__tjB-d`,
	"quantity-input-loading": `LoadingProduct_quantity-input-loading__KMUzh`,
	"quantity-button-loading": `LoadingProduct_quantity-button-loading__Vb8Z6`,
	"loading": `LoadingProduct_loading__Ckj9Y`,
	"gradient": `LoadingProduct_gradient__DBJD8`
};
export default ___CSS_LOADER_EXPORT___;
